module.exports = new __parcel__URL__("insight-recent-object-container-skeleton.tpl.1a59f7d0.svg").toString();